//@----- Global Helper Functions ------
//# Initialize Swiper JS elements
function swiper_init(swiperEl, params = {}) {
  //$ Exit function if the swiper element can't be found
  if (!swiperEl) {
    return;
  }

  //% Example of params
  // const params = {
  //   slidesPerView: 1,
  //   loop: true,
  //   spaceBetween: 30,
  //   pagination: {
  //     type: "fraction",
  //   },
  //   navigation: {
  //     prevEl: HTMLElement,
  //     nextEl: HTMLElement,
  //   },

  //   //# Injecting Styles into slider
  //   injectStyles: [
  //     `
  //         .swiper-pagination-current{
  //         font-weight: 700;
  //         }
  //         `,
  //   ],

  //   breakpoints: {
  //     0: {},
  //     1000: {},
  //   },
  //   on: {
  //     init() {},
  //   },
  // };

  //$ assign all parameters to Swiper element
  Object.assign(swiperEl, params);

  //$ initialize it
  swiperEl.initialize();
}

//# Function to trigger custom events on an element
/**
 * Triggers a custom event on an element.
 *
 * @param {HTMLElement} target_element - The element to trigger the event on.
 * @param {string} event_name - The name of the custom event.
 * @param {*} [event_data=null] - Optional data to pass in the event detail.
 */
function triggerEvent(target_element, event_name, event_data = null) {
  const myEvent = new CustomEvent(event_name, { detail: event_data });
  target_element.dispatchEvent(myEvent);
}

//# Function to submit formData to an endpoint
async function submitForm(endpoint, options, honeypot = null) {
  //% Spam filter:
  //% If the form has a honeypot field and it is filled out [only bots will fill this fiedl]
  if (honeypot && honeypot.value) {
    throw new Error("spam");
  }

  //% API request
  const request = await fetch(endpoint, options);
  // console.log(request);

  //% Throw error message is request fails
  if (!request.ok) {
    // console.log(request);
    throw new Error("Request has failed with status code: " + request.status + " - " + request.statusText);
  }

  const response = await request.json();
  // console.log(response);
  return response;
}

//# Used to throttle functions from events to prevent them from being called too many times
/**
 * Returns a function that will be called at most once per delay milliseconds.
 * The function takes an optional boolean log_event as a third argument, which
 * will log the event to the console if set to true.
 * Call this function in the callback section of a event listener and pass arguments.
 * Eg. window.addEventListener("mousemove", throttle_event(callback, delay, do_log ));
 *
 * @param {function} func - The function to be called when the delay has passed.
 * @param {number} delay - The delay between calls in milliseconds.
 * @param {boolean} [log_event=false] - Whether to log the event to the console.
 * @returns {function} The throttled function.
 */

function throttle(func, delay, do_log = false) {
  //% Set initial previous time
  let prev = 0;

  return (...args) => {
    //$ Get current time
    let now = Date.now();

    //$ Check if delay has passed by comparing the current and previous time
    if (now - prev > delay) {
      //$ Update previous time
      prev = now;

      //$ Log the event if set to true
      if (do_log) {
        console.log(event);
      }

      //$ Return the callback function passed as argument
      return func(...args);
    }
  };
}

//# Function to delay an event function trigger by a certain amount of time after event has stopped
/**
 * Creates a debounced function that delays the invocation of the provided
 * function until after the specified timeout period has passed since the last
 * time the debounced function was called. Useful for limiting the rate at
 * which a function can be executed.
 *
 * @param {function} func - The function to debounce.
 * @param {number} [timeout=300] - The number of milliseconds to delay
 * the function execution.
 * @returns {function} A new debounced function.
 */

function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    //$ Not needed since this gets inherited in arrow functions
    // const context = this;

    //% Remove the previous timeout
    clearTimeout(timer);

    //% Arrow function callback RETURNS the function
    timer = setTimeout(() => func.apply(this, args), timeout);
  };
}

//# Function to check if user is on mobile device
/**
 * Determines if the user is on a mobile device in portrait orientation.
 *
 * @returns {boolean} True if the user is on a mobile device and the
 * orientation is portrait, otherwise false.
 */

function isMobile() {
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const isPortrait = window.matchMedia("(orientation: portrait)").matches;

  if (isMobile && isPortrait) {
    return true;
  }
  return false;
}
